

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import _ from 'lodash'
import locale from 'element-ui/lib/locale'
import store from '@/store'
import en from './modules/en'
import zh_CN from './modules/zh-CN'
import ru_RU from './modules/ru-RU'
import el_en from 'element-ui/lib/locale/lang/en'
import el_zh_CN from 'element-ui/lib/locale/lang/zh-CN'
import el_ru_RU from 'element-ui/lib/locale/lang/ru-RU'
Vue.use(VueI18n)

const messages = {
  'en': { ...en, ...el_en },
  'zh-CN': { ...zh_CN, ...el_zh_CN },
  'ru-RU':{ ...ru_RU, ...el_ru_RU}
}

const i18n = new VueI18n({ silentTranslationWarn: true, locale: store.state.app.appLanguage, messages })

// locale.use(i18n.locale)

locale.i18n((key, value) => i18n.t(key, value))

export const translate = (text, options = {}) => {
  if (!text) return ''
  return _.get(_.merge(messages, options), `${i18n.locale}['${text}']`) || text
}
export const i18nSet = (lang = 'zh-CN') => {
  i18n.locale = lang
  store.dispatch('system/setLanguage', lang)
  return lang
}

export const i18nLoad = (lang) => {
  return new Promise((resolve) => {
    resolve(i18nSet(lang))
  })
}

export const i18nRender = (key) => {
  return i18n.t(`${key}`)
}


Vue.prototype.$translate = translate

export default i18n
